import { createQuery } from '@amzn/gsce-shared-react-lib';
import type {
  GetAuditQuestionResponseRequest,
  GetAuditQuestionResponseResponse,
} from 'src/types/helios/QuestionResponse';
import { questionResponseService, withRetry } from '../../../shared/data';
import { AuditQueryKeys } from './keys';

/**
 * Query hook for fetching a single audit question response
 * (auditor's PASS/FAIL/NA result, comments, and evidence media).
 *
 * Used by the task detail question panel to show the audit response
 * the task was created from.
 *
 * Uses the legacy REST questionResponseService (raw endpoint) rather
 * than the typed SDK client: the question APIs return epoch-number
 * timestamps which fail the Smithy RFC-3339 deserializer. Same service
 * the desktop TaskAuditQuestionResponsePanel uses.
 *
 * Usage:
 * ```tsx
 * const { data } = useAuditQuestionResponseQuery(
 *   { businessUnitId, auditId, questionId },
 *   { enabled: !!businessUnitId && !!auditId && !!questionId },
 * );
 * ```
 */
export const useAuditQuestionResponseQuery = createQuery(
  AuditQueryKeys.questionResponse,
  (input: GetAuditQuestionResponseRequest): Promise<GetAuditQuestionResponseResponse> =>
    withRetry(() => questionResponseService.getById(input)),
);
